import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { FiMinus, FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';

import { measureTypeForm } from '../../../../support/services/formatter';
import { Image } from '../../../components';

import './styles.css';

const useOfferModal = (commands) => {
  const { offerId } = useParams();
  const location = useLocation();
  const history = useHistory();

  const [orderAmount, setOrderAmount] = useState(1);
  const [visible, setVisible] = useState(false);

  const handleClose = () => {
    if (visible) setVisible(false);
    history.push(location.pathname.split('/offers')[0]);
  };

  const handleBasketAddition = (offer, e) => {
    e.preventDefault();

    commands
      .addItemToBasket(offer, orderAmount)
      .then(() => {
        handleClose();
        toast('Oferta adicionada à cesta.', { type: toast.TYPE.SUCCESS });
      })
      .catch((err) => toast(err.message, { type: toast.TYPE.WARNING }));
  };

  const handleAmountChange = (newAmount) => setOrderAmount(newAmount);

  useEffect(() => {
    // Handle back button pressed
    if (!visible && location.pathname.includes('offers')) {
      setVisible(true);
    }
    if (visible && !location.pathname.includes('offers') && location.pathname !== '/') {
      setVisible(false);
    }
    if (visible) {
      setOrderAmount(1);
    }
  }, [location, visible]);

  return {
    localStates: {
      offerId,
      orderAmount,
      visible,
    },
    eventsHandlers: {
      handleClose,
      handleBasketAddition,
      handleAmountChange,
    },
  };
};

export default function OfferModal(props) {
  const {
    remoteStates: { space, offers },
    commands
  } = props;

  const { localStates, eventsHandlers } = useOfferModal(commands);

  const selectedOffer = useMemo(() => (offers?.length
    ? offers.find((offer) => offer.id.toString() === localStates.offerId)
    : null),
  [offers, localStates.offerId]);

  const leadTimeToText = useMemo(() => {
    if (!selectedOffer) return ' - ';

    const leadTimeScaleTag = selectedOffer.leadTime[selectedOffer.leadTime.length - 1];

    return {
      d: `${Number(selectedOffer.leadTime.replace('d', ''))} dia${Number(selectedOffer.leadTime.replace('d', '')) > 1 ? 's' : ''}`,
      h: `${Number(selectedOffer.leadTime.replace('h', ''))} hora${Number(selectedOffer.leadTime.replace('h', '')) > 1 ? 's' : ''}`,
    }[leadTimeScaleTag];
  }, [selectedOffer]);

  const imageUrl = selectedOffer?.imagesPaths?.[selectedOffer?.imagesPaths?.length - 1];

  if (!localStates.visible) return <></>;

  return (
    <div className="modal-blur-background">
      <div
        className={`offer-modal-wrapper ${selectedOffer?.type === 'scheduled_delivery' ? 'modal-scheduled-delivery' : 'modal-prompt-delivery'}`}
        style={{
          transform: localStates.visible ? 'translateY(0vh)' : 'translateY(-100vh)',
          opacity: localStates.visible ? '1' : '0',
        }}
      >
        <div className="offer-modal-header">
          <h3>
            {{
              prompt_delivery: 'Pronta entrega',
              scheduled_delivery: 'Encomenda',
            }[selectedOffer?.type]}
          </h3>
          <span className="close-modal-btn" onClick={eventsHandlers.handleClose}>×</span>
        </div>
        <div className="modal-scroll">
          <div className="modal-body">
            <Image className="modal-image" src={imageUrl} alt={`Foto do produto ${selectedOffer?.name}`} />

            <section>
              <div className="modal-summary">
                <div>
                  <p className="modal-name">{selectedOffer?.name}</p>
                  <p className="modal-amount">
                    {selectedOffer?.type === 'scheduled_delivery'
                      ? `${leadTimeToText} para preparar`
                      : `${selectedOffer?.availableStock} disponíve${selectedOffer?.availableStock < 2 ? 'l' : 'is'}`}
                  </p>
                </div>

                <div>
                  <p className="modal-price">{`${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(selectedOffer?.value)}`}</p>
                  <p className="modal-measures">{`${selectedOffer?.measureQuantity} ${measureTypeForm(selectedOffer?.measureType, selectedOffer?.measureQuantity)}`}</p>
                </div>
              </div>

              {space?.status === 'active'
                && (
                  <form onSubmit={(e) => eventsHandlers.handleBasketAddition(selectedOffer, e)} className="modal-input">
                    <div className="input-wrapper">
                      <div>
                        <FiPlus onClick={() => eventsHandlers.handleAmountChange(localStates.orderAmount + 1 <= selectedOffer?.availableStock || selectedOffer?.type === 'scheduled_delivery' ? localStates.orderAmount + 1 : selectedOffer?.availableStock)} size={26} color="#222" strokeWidth="0.8" />
                        <FiMinus onClick={() => eventsHandlers.handleAmountChange(localStates.orderAmount - 1 >= 0 ? localStates.orderAmount - 1 : 0)} size={26} color="#222" strokeWidth="0.8" />
                      </div>

                      <input
                        name="quantity"
                        type="number"
                        placeholder="0"
                        onChange={(e) => eventsHandlers.handleAmountChange(e.target.value > selectedOffer?.availableStock && selectedOffer?.type !== 'scheduled_delivery' ? selectedOffer?.availableStock : e.target.value < 0 ? 0 : e.target.value)}
                        value={localStates.orderAmount}
                      />
                    </div>

                    <button type="submit">Adicionar à cesta</button>
                  </form>
                )}

              <p className="modal-description">{selectedOffer?.description}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
